import { maintenanceFastTickThresholdMs } from './maintenance-tick-interval';

const millisecondsPerSecond = 1000;
const secondsPerMinute = 60;
const secondsPerHour = 3600;

/**
 * Formats a remaining duration as a countdown.
 *
 * Die Genauigkeit folgt derselben Schwelle wie der Takt in `maintenanceTickIntervalMs`: oberhalb einer
 * Stunde wird nur alle 60 Sekunden neu gerechnet, eine Sekundenstelle stünde dort also fast eine Minute
 * still und sähe aus wie eine stehengebliebene Uhr. Deshalb `HH:MM` mit dem Zusatz "Std." und erst ab einer
 * Stunde Restzeit die sekundengenaue Form. Beide Werte hängen an derselben Konstante, damit Anzeige und
 * Takt nicht auseinanderlaufen können.
 *
 * Durations of a day or more keep counting up in hours (`26:00 Std.`), a duration that has already
 * elapsed is rendered as `00:00:00`.
 * @param ms The remaining duration in milliseconds, `null` when no timestamp is known.
 * @returns The formatted countdown, `null` when there is nothing to count down to.
 */
export function formatCountdown(ms: number | null): string | null {
  if (ms === null) {
    return null;
  }

  const totalSeconds = ms > 0 ? Math.floor(ms / millisecondsPerSecond) : 0;

  const hours = Math.floor(totalSeconds / secondsPerHour);
  const minutes = Math.floor((totalSeconds % secondsPerHour) / secondsPerMinute);
  const seconds = totalSeconds % secondsPerMinute;

  if (ms > maintenanceFastTickThresholdMs) {
    return `${padTwoDigits(hours)}:${padTwoDigits(minutes)} Std.`;
  }

  return `${padTwoDigits(hours)}:${padTwoDigits(minutes)}:${padTwoDigits(seconds)}`;
}

function padTwoDigits(value: number): string {
  return value.toString().padStart(2, '0');
}
